import { render, staticRenderFns } from "./upcoming_orders_widget.vue?vue&type=template&id=13d2f071&scoped=true&"
import script from "./upcoming_orders_widget.vue?vue&type=script&lang=js&"
export * from "./upcoming_orders_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2f071",
  null
  
)

export default component.exports